import { ChangeDetectorRef, Component, Injector, Input, Optional, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatColumnDef, MatTable } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Columns, CrudRevisionEntity, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { Asset, MaintenanceAspect } from 'assets-model';
import { MaintenanceAspectService, RefCodeStorage } from 'assets-service';
import { MaintenanceAspectSearchComponentBase } from './maintenance-aspect-search.component.base';


// @Component({
//   selector: 'app-maintenance-aspect-search',
//   templateUrl: './maintenance-aspect-search.component.html',
//   styleUrls: ['./maintenance-aspect-search.component.scss']
// })
export class MaintenanceAspectSearchComponent extends MaintenanceAspectSearchComponentBase {

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected maintenanceAspectService: MaintenanceAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, maintenanceAspectService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}

@Component({
  selector: 'app-maintenance-aspect-search-result-columns',
  templateUrl: './maintenance-aspect-search-result-columns.component.html',
  styleUrls: ['./maintenance-aspect-search.component.scss']
})
export class MaintenanceAspectSearchResultColumnsComponent {
  @ViewChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

  constructor(@Optional() public table: MatTable<any>, private cdRef: ChangeDetectorRef) { }

  @Input()
  columns: Columns;

  @Input()
  cellClassFn = (element: MaintenanceAspect, fieldName: any, relationshipGetter?: (element: Asset) => any, previousRevisionGetter?: (record: CrudRevisionEntity) => CrudRevisionEntity) => { };

  @Input()
  assetGetter: (record: any) => Asset;

  @Input()
  maintenanceAspectGetter: (record: any) => MaintenanceAspect;

  @Input()
  previousRevisionGetter: (record: CrudRevisionEntity) => CrudRevisionEntity


  ngOnInit() {
    if (!this.assetGetter) {
      this.assetGetter = (record: any) => record;
    }
    if (!this.maintenanceAspectGetter) {
      this.maintenanceAspectGetter = (record: any) => record?.maintenanceAspect;
    }

    if (this.table) {
      this.cdRef.detectChanges();
      this.columnDefs.forEach(columnDef => {
        this.table.addColumnDef(columnDef);
      });
    }
  }

  cellClass(element: MaintenanceAspect, fieldName: string, relationshipGetter?: (element: Asset) => any, previousRevisionGetter?: (record: CrudRevisionEntity) => CrudRevisionEntity) {
    return this.cellClassFn(element, fieldName, relationshipGetter, previousRevisionGetter);
  }
}

